import { SupportedRegions } from "@nova/constants"
import { z } from "zod"

export const knownOrganizationSettings = z.discriminatedUnion("name", [
    z.object({
        name: z.literal("liveVideoRecordingBlocked"),
        value: z.boolean().default(false),
    }),
    z.object({
        name: z.literal("region"),
        value: z.enum(SupportedRegions).default(SupportedRegions.Canada),
    }),
    z.object({
        name: z.literal("slackNotificationsSilenced"),
        value: z.boolean().default(false),
    }),
])

export type KnownOrganizationSetting = z.infer<typeof knownOrganizationSettings>["name"]
